var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-main"},[_c('div',{staticClass:"main-cont-router"},[_c('MainRouteKeepAlive',{ref:"mainRoute"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }